function Button({ id, children, onClick, className = "" }) {
	return (
		<div
			id={id}
			className={`flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-br from-accent-100 to-accent-200 py-2 px-4 text-center font-semibold text-white drop-shadow-md duration-200 hover:-translate-y-0.5 hover:from-accent-200 hover:to-accent-300 ${className}`}
			onClick={onClick}
		>
			{children}
		</div>
	);
}

export default Button;
